<template>
  <vs-table class="w-full p-0 expandable-contratto" :data="value">
    <template slot="thead">
    </template>
    <template slot-scope="{data}">
      <colgroup ref="colgrouptable">
        <col :key="0" :name="`col-0`" width="3%"/>
        <col :key="1" :name="`col-1`" width="10%"/>
        <col :key="2" :name="`col-2`" width="10%"/>
        <col :key="3" :name="`col-3`" width="10%"/>
        <col :key="4" :name="`col-4`" width="35%"/>
        <col :key="5" :name="`col-5`" width="12%"/>
        <col :key="6" :name="`col-6`" width="12%"/>
        <col :key="7" :name="`col-7`" width="12%"/>
      </colgroup>
      <vs-tr class="shadow" :data="tr" :key="indextr" v-for="(tr, indextr) in value">
          <vs-td :key="0">
          </vs-td>

          <vs-td :data="tr.creatore" :key="1">
              {{tr.creatore.nome}}
          </vs-td>

          <vs-td :data="tr.data" :key="2">
              {{formatDate(tr.data_emissione)}}
          </vs-td>

          <vs-td class="text-center" :data="tr.stato" :key="3">
            <vs-button class="no-pointer-event inline-block" type="border" size="small" :color="stato[tr.stato.stato]">{{tr.stato.stato}}</vs-button>
          </vs-td>

          <vs-td :data="cliente" :key="4">
              {{cliente.ragione_sociale}}
          </vs-td>

          <vs-td :data="voce.servizio" :key="5">
              {{voce.tariffa_applicata.servizio.categoria}}
          </vs-td>

          <vs-td :data="voce.tariffa" :key="6">
              {{voce.tariffa_applicata.tariffa.nome}}
          </vs-td>

          <vs-td class="text-center" :key="7">
              <vs-button @click="openSidebarContratto(preventivo, indextr, $event)" class="inline-block" radius color="primary" size="small" type="border" icon-pack="feather" icon="icon-search"></vs-button>
              <!-- <vs-button @click="copyContratto(preventivo, indextr, $event)" class="inline-block ml-2" radius color="warning" size="small" type="border" icon-pack="feather" icon="icon-copy"></vs-button> -->
          </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>

export default {
    name: "expandable-contratto",
    props: {
            preventivo: Object,
            value: Array,
            voce: Object,
            cliente: Object,
    },
    data() {
        return {
          stato: {
            'Accettato': 'success',
            'Aperto': 'warning',
            'Rifiutato': 'danger',
            'Inviato': 'warning',
            'Consegnato': 'dark',
            'Revisionato': 'warning'
          },
        }
    },
    methods: {
        formatDate(date) {
          date = new Date(date)
          return date.getDate()+'-'+(((date.getMonth()+1) < 10) ? '0'+(date.getMonth()+1) : (date.getMonth()+1))+'-'+date.getFullYear()
        },
        openSidebarContratto(preventivo, index_contratto, ev) {
          this.$emit('contratto', preventivo, index_contratto)
          ev.stopPropagation()
        },
        copyContratto(preventivo, index_contratto, ev) {
          this.$emit('copy', preventivo, index_contratto)
          ev.stopPropagation()
        }
    },
}
</script>
